import axios from 'axios'

var instance = axios.create({
    timeout:30000,//超时时间
    withCredentials:true,//意思是携带cookie信息,保持session的一致性
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        // 'Content-Type': 'application/json;charset=utf-8'
    }
})
export default instance;